import React from "react";
import PropTypes from "prop-types";
import StyledFilterProductPriceFlower from "./FilterProductPriceFlower.styled";
import FilterPriceRadioFlower from "./FilterPriceRadioFlower";
import { filterRangePT } from "../../config/prop-types";

const FilterProductPriceFlower = React.memo(props => {
    const {
      className,
      heading,
      productPriceRange,
      checkFilter,
      checkedFilter,
      clearFilter,
      clearFilerBool,
      selected,
      disabled
    } = props;

  return (
    <StyledFilterProductPriceFlower className={className}>
      <div className="filter-product-price__header">
        <h3 className="t-aside-heading filter-product-price__heading">{heading}</h3>
          {clearFilerBool && 
            <button onClick={clearFilter} className={`t-form-button filter-product-type__clear ${selected && selected > 0 ? 'selected':''}`}>Clear All
                {selected && selected > 0 ? <span> ({selected})</span>:''}
            </button>
          }
      </div>
      {productPriceRange.map((range) => (
        <li className="filter-product-price__type" key={range.id}>
          <FilterPriceRadioFlower
            range={range}
            checkFilter={checkFilter}
            checked={checkedFilter === range.id.toString()}
            disabled={disabled}
          />
        </li>
      ))}
    </StyledFilterProductPriceFlower>
  );
});

FilterProductPriceFlower.propTypes = {
  heading: PropTypes.string,
  productPriceRange: PropTypes.arrayOf(filterRangePT).isRequired,
  className: PropTypes.string,
  checkFilter: PropTypes.func.isRequired,
  checkedFilter: PropTypes.string.isRequired,
  priceRange: PropTypes.array.isRequired,
  disabled: PropTypes.bool.isRequired,
};

export default FilterProductPriceFlower;